import { render, staticRenderFns } from "./DrePayableReceivable.vue?vue&type=template&id=838f5270&"
import script from "./DrePayableReceivable.vue?vue&type=script&lang=js&"
export * from "./DrePayableReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports